<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p10" title="10">
<h1 class="chaptername" id="AA2"><span class="line_top">chapter one</span></h1>
<h1 class="chaptertitle">Breakfast &amp; Brunch</h1>
<p class="chap_toc"><a href="#/html/p013#chocolate_cherry_bread">Chocolate-Cherry Bread</a></p>
<p class="chap_toc"><a href="#/html/p014#monkey_bread">Monkey Bread</a></p>
<p class="chap_toc"><a href="#/html/p017#five_grain_buttermilk_cranberry_bread">Five-Grain Buttermilk-Cranberry Bread</a></p>
<p class="chap_toc"><a href="#/html/p018#the_ultimate_pancakes">The Ultimate Pancakes</a></p>
<p class="chap_toc"><a href="#/html/p021#upside_down_banana_walnut_french_toast">Upside-Down Banana-Walnut French Toast</a></p>
<p class="chap_toc"><a href="#/html/p022#apricot_stuffed_french_toast">Apricot-Stuffed French Toast</a></p>
<p class="chap_toc"><a href="#/html/p024#caramel_sticky_rolls">Caramel Sticky Rolls</a></p>
<p class="chap_toc"><a href="#/html/p027#frozen_blueberry_breakfast_bars">Frozen Blueberry Breakfast Bars</a></p>
<p class="chap_toc"><a href="#/html/p028#apple_crisp_refrigerator_oatmeal">Apple Crisp Refrigerator Oatmeal</a></p>
<p class="chap_toc"><a href="#/html/p031#make_it_your_own_oatmeal">Make-It-Your-Own Oatmeal</a></p>
<p class="chap_toc"><a href="#/html/p032#cheesy_sausage_and_egg_bake">Cheesy Sausage and Egg Bake</a></p>
<p class="chap_toc"><a href="#/html/p035#spinach_pesto_egg_bakes">Spinach-Pesto Egg Bakes</a></p>
<p class="chap_toc"><a href="#/html/p036#impossibly_easy_mini_breakfast_sausage_pies">Impossibly Easy Mini Breakfast Sausage Pies</a></p>
<p class="chap_toc"><span href="#/html/p039#ham_and_swiss_breakfast_hand_pies" title="Link target outside of Sample">Ham and Swiss Breakfast Hand Pies</span></p>
<p class="chap_toc"><span href="#/html/p040#sausage_wrapped_stuffed_chiles" title="Link target outside of Sample">Sausage-Wrapped Stuffed Chiles</span></p>
<p class="chap_toc"><span href="#/html/p041#egg_and_sausage_breakfast_ring" title="Link target outside of Sample">Egg and Sausage Breakfast Ring</span></p>
<p class="chap_toc"><span href="#/html/p042#smoked_sausage_spinach_pie" title="Link target outside of Sample">Smoked Sausage Spinach Pie</span></p>
<p class="chap_toc"><span href="#/html/p045#bacon_and_hash_brown_egg_bake" title="Link target outside of Sample">Bacon and Hash Brown Egg Bake</span></p>
<p class="chap_toc"><span href="#/html/p046#chicken_fajita_strata" title="Link target outside of Sample">Chicken Fajita Strata</span></p>
<p class="chap_toc"><span href="#/html/p051#fruity_green_smoothies" title="Link target outside of Sample">Fruity Green Smoothies</span></p>
<p class="chap_toc"><span href="#/html/p052#skinny_tropical_smoothies" title="Link target outside of Sample">Skinny Tropical Smoothies</span></p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p010.vue?df2cd8a0